import React from "react";

const UserBlock = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill || "#4E525F"}
            d="M15.602 19.454c4.806 0 8.702-3.907 8.702-8.727S20.408 2 15.602 2s-8.701 3.907-8.701 8.727 3.896 8.727 8.701 8.727Zm4.351 7.273a4.357 4.357 0 0 1 4.351-4.363c.672 0 1.308.152 1.876.425l-5.803 5.82a4.357 4.357 0 0 1-.424-1.882Zm2.475 3.939 5.803-5.82c.272.57.424 1.208.424 1.881a4.357 4.357 0 0 1-4.35 4.364 4.323 4.323 0 0 1-1.877-.425Zm1.876-11.212c-4.005 0-7.251 3.257-7.251 7.273 0 4.017 3.246 7.273 7.251 7.273 4.005 0 7.252-3.256 7.252-7.273 0-4.016-3.247-7.273-7.252-7.273Zm-8.702 1.455c.123 0 .244.002.366.006a10.155 10.155 0 0 0-1.816 5.812c0 2.163.673 4.17 1.82 5.818H4C4 26.12 9.195 20.91 15.602 20.91Z"
        />
    </svg>
);

export default UserBlock;
